var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 89,
    viewBox: "0 0 135 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4289_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6662 84.2688L83.4818 66.5126H97.4522C115.671 66.5126 130.441 51.7431 130.441 33.5243C130.441 15.3053 115.671 0.536133 97.4522 0.536133H33.2528C15.034 0.536133 0.264648 15.3053 0.264648 33.5243C0.264648 51.7431 15.034 66.5126 33.2528 66.5126H68.5743L68.6662 84.2688Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 17.7559H101.97",
    stroke: "white",
    strokeWidth: 2.8884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0176 32.0698H101.969",
    stroke: "white",
    strokeWidth: 2.8884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 46.3838H101.97",
    stroke: "white",
    strokeWidth: 2.8884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.906 57.6097C110.787 56.5833 112.945 56 115.238 56C122.55 56 128.477 61.9271 128.477 69.2385C128.477 72.8121 127.061 76.0549 124.76 78.4366L108.906 57.6097ZM105.724 60.0333C103.419 62.4157 102 65.6614 102 69.2385C102 76.5499 107.927 82.477 115.238 82.477C117.536 82.477 119.696 81.8919 121.579 80.8626L105.724 60.0333ZM115.238 52C105.718 52 98 59.7179 98 69.2385C98 78.7591 105.718 86.477 115.238 86.477C124.759 86.477 132.477 78.7591 132.477 69.2385C132.477 59.7179 124.759 52 115.238 52Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.906 57.6097L124.76 78.4366C125.235 77.9444 125.673 77.4153 126.069 76.8541C127.586 74.7002 128.477 72.0734 128.477 69.2385C128.477 61.9271 122.55 56 115.238 56C113.674 56 112.173 56.2713 110.78 56.7695C110.131 57.0017 109.505 57.2833 108.906 57.6097ZM112.063 58.4544L124.787 75.1699C125.859 73.4482 126.477 71.4166 126.477 69.2385C126.477 63.0316 121.445 58 115.238 58C114.134 58 113.069 58.1588 112.063 58.4544ZM105.696 63.2983C104.62 65.0219 104 67.0567 104 69.2385C104 75.4453 109.032 80.477 115.238 80.477C116.347 80.477 117.415 80.3172 118.424 80.0197L105.696 63.2983ZM104.414 61.6146C102.893 63.77 102 66.3999 102 69.2385C102 76.5499 107.927 82.477 115.238 82.477C116.806 82.477 118.311 82.2044 119.706 81.7041C120.356 81.4714 120.981 81.1894 121.579 80.8626L105.724 60.0333C105.248 60.5252 104.81 61.0538 104.414 61.6146ZM96 69.2385C96 58.6134 104.613 50 115.238 50C125.864 50 134.477 58.6134 134.477 69.2385C134.477 79.8636 125.864 88.477 115.238 88.477C104.613 88.477 96 79.8636 96 69.2385ZM98 69.2385C98 59.7179 105.718 52 115.238 52C124.759 52 132.477 59.7179 132.477 69.2385C132.477 78.7591 124.759 86.477 115.238 86.477C105.718 86.477 98 78.7591 98 69.2385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4289_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 89,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessagesIcon);
export default __webpack_public_path__ + "static/media/no-messages-icon.c4fc6cab92e5523683bf6240eafa8534.svg";
export { ForwardRef as ReactComponent };